import { Controller } from "@hotwired/stimulus"

// Fills in the signed-in account menu on a page Cloudflare keeps.
//
// A kept page is one copy for everybody, so its header is drawn signed out and
// a signed-in reader, staff included, saw no account menu on it. Whether
// anybody is signed in is only knowable from this browser, so this asks: when
// the `signed_in` hint cookie is present it fetches /account/menu, which is
// private and never stored, and swaps the answer into the slot at the end of
// the bar. No hint, no request, so a signed-out reader costs nothing.
//
// Only attached to the header of a kept page (SiteHeaderComponent's
// `account_menu_deferred?`); every other page draws the menu on the server.
export default class extends Controller {
  static targets = ["slot"]
  static values = { url: String }

  connect() {
    if (!/(?:^|;\s*)signed_in=1(?:;|$)/.test(document.cookie)) return
    this.load()
  }

  async load() {
    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("path", window.location.pathname)

    let response
    try {
      response = await fetch(url, { credentials: "same-origin", headers: { Accept: "text/html" } })
    } catch {
      return // offline or blocked: the signed-out bar is still a working bar
    }
    // 204 means the hint outlived the session; the server has cleared it.
    if (response.status !== 200 || !this.hasSlotTarget) return

    this.slotTarget.innerHTML = await response.text()
  }
}
